import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const FacebookScaleSmallAppearanceOutlined = hoc(
    (props: IconProps) => (
        <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M5.94873 14.7692C5.94873 14.9533 6.09797 15.1026 6.28207 15.1026H8.69232C8.87642 15.1026 9.02566 14.9533 9.02566 14.7692V9.04728H10.5641C10.7319 9.04728 10.8735 8.92262 10.8948 8.75623L11.2025 6.34998C11.2146 6.25498 11.1853 6.15934 11.122 6.08745C11.0587 6.01556 10.9676 5.97436 10.8718 5.97436H9.02566V4.64183C9.02566 4.28261 9.09101 4.0921 9.15878 4.00266C9.23474 3.91101 9.42112 3.8117 9.84617 3.8117H11.0769C11.261 3.8117 11.4103 3.66247 11.4103 3.47837V1.33654C11.4103 1.17189 11.29 1.0319 11.1273 1.00703C10.6425 0.932962 10.0256 0.897441 9.28207 0.897441C8.30251 0.897441 7.48499 1.20052 6.86511 1.82978C6.24035 2.464 5.94873 3.3379 5.94873 4.40385V5.97436H4.30771C4.12361 5.97436 3.97438 6.1236 3.97438 6.3077V8.71395C3.97438 8.89804 4.12361 9.04728 4.30771 9.04728H5.94873V14.7692Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                strokeWidth={0.666667}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    'Facebook'
);
export default FacebookScaleSmallAppearanceOutlined;
